import Form from "../components/form";

const Onboarding = () => {

     return (
          <div className="onboarding">
               <h1>Tutor onboarding form</h1>
               <p>We’re happy to officially welcome you to the team!<br />Please fill out the form below so we can get started!</p>
               <Form formId="Onboarding" />
          </div>
     );
};

export default Onboarding;